import { useEffect, useRef } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import { EffectComposer, RenderPass } from 'postprocessing';
import { N8AOPostPass } from 'n8ao';

// سایه‌ی گوشه‌ها (SSAO با N8AO) در صحنه‌ی زنده‌ی سه‌بعدی.
// فعال فقط وقتی آدرس صفحه شامل ?ao=1 باشد — پیش‌فرض خاموش است، پس برای بقیه‌ی کاربران هیچ تغییری ندارد.
// آزمایش: همان صفحه را با ?ao=1 باز کن و با/بدونش مقایسه کن.
export const SSAO_ON = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('ao');

// چون وقتی این پاس فعال است رندرِ R3F به ما واگذار می‌شود، فقط در حالت فعال این بخش ساخته می‌شود
// (اگر همیشه بود، حتی خاموش هم صحنه سیاه می‌ماند).
export function SsaoPass({ enabled }) {
  if (!enabled) return null;
  return <SsaoLoop />;
}

function SsaoLoop() {
  const { gl, scene, camera, size } = useThree();
  const composerRef = useRef(null);

  useEffect(() => {
    const composer = new EffectComposer(gl);
    composer.addPass(new RenderPass(scene, camera));
    const ao = new N8AOPostPass(scene, camera, size.width, size.height);
    // شعاعِ تأثیر بر حسبِ واحدِ صحنه (گروهِ ساختمان با مقیاسِ M). اگر تیره‌تر/روشن‌تر بود، این دو عدد را تنظیم کن
    ao.configuration.aoRadius = 0.6;
    ao.configuration.intensity = 2;
    composer.addPass(ao);
    composerRef.current = composer;
    return () => {
      composer.dispose();
      composerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gl, scene, camera]);

  useEffect(() => {
    if (composerRef.current) composerRef.current.setSize(size.width, size.height);
  }, [size.width, size.height]);

  // اولویتِ ۱ یعنی رندر را خودمان انجام می‌دهیم (به‌جای رندرِ خودکارِ R3F)
  useFrame(() => {
    if (composerRef.current) composerRef.current.render();
  }, 1);

  return null;
}
